
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 31 27","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"31","height":"27","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAQAAAAuNpykAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGQmAf+nAAAAC8klEQVQ4y42UT2xUZRDAf69UY7cBm2BpXFtMTWmwIoJBu+9tSdSLSaNSGyNEo+nBk148ePDPRaMJqPFPSNSLNiFGPRgBDRpvaOi+t2QLFaH8KaKNNBrBRqNtgdrtz0O3tNut2JnTNzO/N/PNm/kCWUTa2U8Nk/zFb4wwxDG+4zBTlYHBIvhaDnCGXlKsIM0NtNFMwDgH+JzdnCuLdaE2es6zbnG99ZdtKe/yRfuctuhX3m/VrGchXOdRp5yVMfO+b4/NJW/ap/xe/cEeqyvxlH2OeqdNrrHDrb7gRx5X47KozX6tDtlZji/zCycMRWzyNq8u2ettq7jiPR5Vv50zBPb6j52l0zPqlP2+bafXzMNafMz3PGJRvaRznd/Os/Swq3SqYwO3kmUzacbZRx8pIkJWAWeIScjRwmezX31aHXfYgnvccjlX2of90BGn1Qv2+apdrhJv8lHf9UetBuAR3mIfBVI0sJpaNhERkqUJ+IUcefrJU8XtZHmciAbgJ87SjHivk+4y8Drvc7vfOKFOWXCn21wtXu9DvmHiJfWisa/ZbYPYpdVk2Msp4CStwCgJLxNTYJL1ROwg4kbgV2I+JeEQk+VDO0YtcpyYmIRTrKSdDjK0k6LIERJyJAwvshld7EF9yToD23zCXk+oOuqXPu/d1lb87/naNdO6Fj4mpA44QY7XSTjJootYKdVANzHvkCPPH0uD5m+cdl+xxMW03gfc4eBM8dNLzFTFLUREhKwBzjM8U/z/yQoyRISELEeOsZ9XyDPENj65Et5Khiwh6wj4m4Q3ickzxs1keY6IVgiUB9k7D6rhDkKyZKgHTpMQEzNILRlCIjJcOzcnc9kbyRISsZFqLtBPLzEJ52kh5Eki1lHFGAk7yXGQP2enTj5gORGNwEhp9gZYxqZSm+av6CDF8vsFSpHDJfcIaTrIkGUjV3GRQ+RIiBe8rgvwrexmw4IVTYgZKF+P/8JP00gNRQZKbfp56UMX+HsJKjCxdGxW/gUrdRkcSXo3iAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    